<p>Sie werden derzeit eingeloggt. Bitte warten Sie einen Moment!</p>
<button matButton="tonal" (click)="logout()">Abbrechen</button>